import React from 'react';
import {Input} from './Input';
import InputMask from 'react-input-mask';

export const InputPhone = (props) => {
    let {value = '', label, onChange, errors = {}, name = 'phone', required = true, disabled = false, ...other} = props;

    return (
        <InputMask
            mask="+38(\099)999-99-99"
            value={value}
            onChange={({target: {value}}) => onChange(value)}
            alwaysShowMask={true}
            disabled={disabled}
        >
            {(inputProps) => <Input
                {...inputProps}
                type="tel"
                name={name}
                errors={errors}
                variant="standard"
                size={'small'}
                // margin="normal"
                required={required}
                disabled={disabled}
                fullWidth
                placeholder = '+38(050)123-45-67'
                id={name}
                label={label}
                {...other}
            />}
        </InputMask>
    )
};
